import React, { useRef, useState, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Card, Button, Form } from "react-bootstrap";
import { useLoader } from "../../_helper/LoaderContext";
import { addSign } from "./service/setting-service";
import { toast } from "react-toastify";
import { Input, Label } from "reactstrap";
import S3ImageLoader from "../../S3ImageLoader";
import { useLab } from "../../_helper/PharmacyProvider";

export default function SettingHome({ onChange }) {
  const signRef = useRef();
  const [uploadedImage, setUploadedImage] = useState(null);
  const [signName, setSignName] = useState("");
  const [signatureQualification, setSignatureQualification] = useState("");
  const [signaturePreview, setSignaturePreview] = useState(null);
  const { setLoading } = useLoader();
  const fileInputRef = useRef();
  const [imported, setImported] = useState("add");
  const { currentLab, setCurrentLab } = useLab()

  useEffect(() => {
    if (!currentLab?.signatureImage) return;

    setSignaturePreview(currentLab.signatureImage);
    setSignName(currentLab.signatureName || "");
    setSignatureQualification(currentLab.signatureQualification || "");
  }, [currentLab?.signatureImage, currentLab?.signatureName, currentLab?.signatureQualification]);
  // Clear Canvas
  const clearSignature = () => {
    signRef.current.clear();
    setSignaturePreview(null);
    onChange && onChange(null);
  };

  // Convert canvas to preview when drawing
  const updateCanvasPreview = () => {
    if (!signRef.current.isEmpty()) {
      const dataURL = signRef.current.toDataURL("image/png");
      // setSignaturePreview('');
    }
  };

  // Handle uploaded file
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const imgURL = URL.createObjectURL(file);
    setUploadedImage(imgURL);
    // setSignaturePreview(imgURL);
  };

  const submit = async () => {
    setLoading(true);

    try {
      const form_data = new FormData();
      form_data.append("signatureName", signName);
      form_data.append("signatureQualification", signatureQualification);

      // const uploadedFile = fileInputRef.current.files[0];
      // const isCanvasEmpty = signRef.current.isEmpty();
      if (imported === "add") {
        const dataURL = signRef.current.toDataURL("image/png");
        const blob = await (await fetch(dataURL)).blob();
        form_data.append("signatureImage", blob, "signature.png");
      } else if (imported !== "add") {
        const uploadedFile = fileInputRef.current.files[0];
        form_data.append("signatureImage", uploadedFile);
      }

      else {
        toast.warning("Please draw or upload a signature");
        setLoading(false);
        return;
      }

      // 👉 Call API
      const res = await addSign(form_data);

      if (res.data.success === true) {
        toast.success(res.data.message);
        localStorage.setItem("currentLab", JSON.stringify(res.data.data))
        setCurrentLab(res.data.data)
        // Reset UI
        // setSignName("");
        setUploadedImage(res.data.data.signatureImage);

        signRef.current.clear();
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      }

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };


  const handleRadio = (e) => {
    const value = e.target.value;
    setImported(value);
    // setSignaturePreview(null);
    setUploadedImage(null);
    if (signRef.current) signRef.current.clear();
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <Card className="p-4">

            {/* Radio Button */}
            <div className="d-flex tw-space-x-4 mb-2">
              <div className="radio radio-primary">
                <Input
                  id="customer-radio-add"
                  type="radio"
                  name="customerType"
                  value="add"
                  checked={imported === "add"}
                  onChange={handleRadio}
                />
                <Label for="customer-radio-add" className="mb-0 pe-2">Manual</Label>
              </div>

              <div className="radio radio-primary">
                <Input
                  id="customer-radio-global"
                  type="radio"
                  name="customerType"
                  value="gloabal"
                  checked={imported === "gloabal"}
                  onChange={handleRadio}
                />
                <Label for="customer-radio-global" className="mb-0 pe-2">Upload Image</Label>
              </div>
            </div>

            <div className="row">

              {/* LEFT SIDE - DRAW OR UPLOAD */}
              <div className="col-md-6">

                {imported === "add" ? (
                  <div className="border rounded p-2">

                    {/* Draw Section */}
                    <div className="tw-flex mb-2 tw-justify-between">
                      <p className="fw-bold">Draw Signature</p>
                      <div className="">
                        <button className="btn btn-secondary px-2 py-0" onClick={clearSignature}>
                          Clear
                        </button>
                      </div>
                    </div>

                    <SignatureCanvas
                      ref={signRef}
                      penColor="black"
                      onEnd={updateCanvasPreview}
                      canvasProps={{
                        className: "border w-100 rounded",
                        style: { height: "200px" },
                      }}
                    />

                    {/* Signature Name */}
                    <div className="mt-3 mb-2">
                      <Form.Group>
                        <Form.Label>Signature Name On Lab Report</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter signature name"
                          value={signName}
                          onChange={(e) => setSignName(e.target.value)}
                        />
                      </Form.Group>

                      <Form.Group className="mt-2">
                        <Form.Label>Degree On Lab Report</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter degree name"
                          value={signatureQualification}
                          onChange={(e) => setSignatureQualification(e.target.value)}
                        />
                      </Form.Group>

                      <div className="mt-3">
                        {currentLab.signatureImage !== "" ? (
                          <Button variant="primary" onClick={submit}>
                            Add
                          </Button>
                        ) : (
                          <Button variant="primary" onClick={submit}>
                            Add
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="border rounded p-2">

                    {/* Upload Section */}
                    <p className="fw-bold mb-2 text-center">Upload Signature Image</p>

                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />

                    <div className="text-center">
                      <Button variant="primary" onClick={handleUploadClick}>
                        Upload
                      </Button>
                    </div>

                    {/* Signature Name */}
                    <div className="mt-3">
                      <Form.Group>
                        <Form.Label>Signature Name On Lab Report</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter signature name"
                          value={signName}
                          onChange={(e) => setSignName(e.target.value)}
                        />
                      </Form.Group>

                      <Form.Group className="mt-2">
                        <Form.Label>Degree On Lab Report</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter degree name"
                          value={signatureQualification}
                          onChange={(e) => setSignatureQualification(e.target.value)}
                        />
                      </Form.Group>

                      <div className="mt-3">
                        <Button variant="primary" onClick={submit}>
                          Update
                        </Button>
                      </div>
                    </div>
                  </div>
                )}

              </div>

              {/* RIGHT SIDE - PREVIEW */}
              <div className="col-md-6">
                <div className="border rounded p-3 text-center">

                  <h5 className="fw-bold mb-3">Preview</h5>

                  {/* Signature Preview */}
                  {signaturePreview ? (
                    <S3ImageLoader
                      fileName={signaturePreview}
                      fallbackSrc={''}
                      // className="m-0 rounded-circle border border-5 border-white shadow-lg"
                      alt="signaturePreview"
                      style={{ width: "70%", height: "100px", objectFit: "contain" }}/>
                    // <img
                    //   src={signaturePreview}
                    //   alt="signature preview"
                    //   style={{ width: "70%", height: "100px", objectFit: "contain" }}
                    // />
                  ) : (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ width: "100%", height: "200px", }}
                    >
                      <span className="text-muted">No Signature Preview</span>
                    </div>
                  )}

                  {/* Signature Name Preview */}
                  <div className="mt-3">
                    <p className="fw-bold mb-0">{signName || "No Name Entered"}</p>
                    {signatureQualification ? (
                      <p className="mb-0">{signatureQualification}</p>
                    ) : null}
                  </div>

                </div>
              </div>

            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
